import React from 'react'
import TimesheetEntry from '../components/Timesheet/TimesheetEntry'
const TimeSheet = () => {
  return <TimesheetEntry />
}

export {TimeSheet}